<template>
  <div class="apply-sp">
    <div class="breadcrumb" style="background: #fff">满减活动设置</div>
    <div class="third-title"><span> 基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="100px">
        <el-form-item label="满减对象:">
          <el-button type="primary" @click="selectDialog=true" round>选择满减对象</el-button>
          <el-table :data="[selectedInfo.sku]" border style="width: 100%;margin-top:10px;" v-if="selectedInfo.sku">
            <el-table-column prop="skuName" label="SKU名称"></el-table-column>
            <el-table-column label="SKU组名称">
              <template>{{selectedInfo.skuGroup.skuGroupName}}</template>
            </el-table-column>
            <el-table-column label="属性组合" v-if="!selectedInfo.isSeries">
              <template>{{selectedInfo.skuGroup.dictSet}}</template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="满减规则:" v-if="selectedInfo.sku">
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column label="满足数量">
              <template slot-scope="scope">
                <el-input v-model="scope.row.baseDiscountQty" style="width:100%;"></el-input>
              </template>
            </el-table-column>

            <el-table-column label="基础P数" v-if="!selectedInfo.isSeries">
              <template>
                {{selectedInfo.sku.basePage}}
              </template>
            </el-table-column>
            <el-table-column label="最大P数" v-if="!selectedInfo.isSeries">
              <template>
                {{selectedInfo.sku.maxPage}}
              </template>
            </el-table-column>
            <el-table-column label="增加一次P数" v-if="!selectedInfo.isSeries">
              <template>
                {{selectedInfo.sku.baseStep}}
              </template>
            </el-table-column>

            <el-table-column label="基础P平台价格">
              <template slot-scope="scope">
                <el-input v-model="scope.row.discountBasePagePrice" style="width: 100%"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="基础P在线支付价格">
              <template slot-scope="scope">
                <el-input v-model="scope.row.discountOnlineBasePagePrice" style="width: 100%"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="操作">
              <template slot-scope="scope">
                <span v-show="scope.$index!==tableData.length-1" class="color-blue" @click="deleteRow(scope.$index)">移除</span>
                <span v-show="scope.$index===tableData.length-1" class="color-blue" @click="addRow()">添加</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </div>

    <div class="edit-button">
      <el-button round type="primary" @click="apply()">申请特殊价格</el-button>
    </div>

    <el-dialog :close-on-click-modal="false" title="选择满减对象" :visible.sync="selectDialog" width="800px">
      <el-form ref="selectForm" :model="selectForm" label-width="100px">
        <el-form-item label="产品分类:">
          <el-cascader :show-all-levels="false" v-model="selectForm.categoryId" @change="getSpuList" :props="props"></el-cascader>
        </el-form-item>
        <el-form-item label="选择产品:">
          <el-select v-model="selectForm.selectSpuId" placeholder="请选择" @change="getSpuMsg">
            <el-option v-for="item in spuList" :key="item.id" :value="item.id" :label="item.spuName" style="height: auto"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择SKU组:">

          <el-select v-model="selectForm.skuGroup" value-key="id" @change="getSkuListBySkuGroupId" placeholder="请选择" v-show="!selectForm.isSeries">
            <el-option v-for="item in skuGroupListBySpuId" :key="item.id" :label="item.skuGroupName" :value="item" style="height: auto"></el-option>
          </el-select>

          <el-table :data="skuGroupListBySpuId" border style="width: 100%" v-show="selectForm.isSeries">
            <!-- <el-table-column prop="skuName" label="SKU名称"></el-table-column> -->
            <el-table-column label="SKU组名称">
              <template slot-scope="scope">{{scope.row.skuGroupName}}</template>
            </el-table-column>
            <el-table-column label="SKU组图片">
              <template slot-scope="scope">
                <el-image style="width: 100px; height: 100px" :src="scope.row.skuGroupImage" fit="fit"></el-image>
              </template>
            </el-table-column>
            <!-- <el-table-column label="属性组合">
              <template>{{selectForm.skuGroup.dictSet}}</template>
            </el-table-column> -->
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span class="color-blue" @click="select(scope.row)">选择</span>
              </template>
            </el-table-column>
          </el-table>

        </el-form-item>
        <el-form-item label="SKU" v-show="!selectForm.isSeries">
          <el-table :data="skuList" border style="width: 100%">
            <el-table-column prop="skuName" label="SKU名称"></el-table-column>
            <el-table-column label="SKU组名称">
              <template>{{selectForm.skuGroup.skuGroupName}}</template>
            </el-table-column>
            <el-table-column label="SKU组图片">
              <template>
                <el-image style="width: 100px; height: 100px" :src="selectForm.skuGroup.skuGroupImage" fit="fit"></el-image>
              </template>
            </el-table-column>
            <el-table-column label="属性组合">
              <template>{{selectForm.skuGroup.dictSet}}</template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span class="color-blue" @click="select(scope.row)">选择</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>

    </el-dialog>

  </div>
</template>

<script>
import { categoryList, queryAllSubs, spuList, skuGroupListBySpuId, skuList, skuDiscountRuleAddBatch } from '@/api/pms'

export default {
  components: {
  },
  data () {
    let _this = this
    return {
      tableData: [],
      selectedInfo: {
        isSeries: false,
        skuGroup: '',
        sku: ''
      },
      selectForm: {
        isSeries: false,
        categoryId: '',
        selectSpuId: '',
        skuGroup: ''
      },
      skuGroupListBySpuId: [],
      spuList: [],
      skuList: [],
      selectDialog: false,
      basicInfo: {},
      spuQueryInfo: {
        pageNum: 1,
        pageSize: 100
      },
      props: {
        checkStrictly: true,
        emitPath: false,
        lazy: true,
        lazyLoad (node, resolve) {
          const { level, value } = node
          if (level === 0) {
            categoryList(value).then(res => {
              let nodes = res.data.data.map(item => {
                return {
                  value: item.id,
                  label: item.categoryName,
                  leaf: item.bottom || item.id === 4
                }
              })
              // nodes = nodes.filter(item => {
              //   return item.value === +_this.$route.query.categoryId || item.label === '通用'
              // })
              resolve(nodes)
            })
          } else if (level === 1) {
            queryAllSubs(value).then(res => {
              let nodes = res.data.data.subCategoryList.map(item => {
                return {
                  value: item.id,
                  label: item.categoryName,
                  leaf: item.subCategoryList.length === 0,
                  subCategoryList: item.subCategoryList
                }
              })
              resolve(nodes)
            })
          } else {
            let nodes = node.data.subCategoryList.map(item => {
              return {
                value: item.id,
                label: item.categoryName,
                leaf: item.subCategoryList.length === 0,
                subCategoryList: item.subCategoryList
              }
            })
            resolve(nodes)
          }
        }
      }
    }
  },
  created () {
  },
  methods: {
    apply () {
      if (this.tableData.length === 1) {
        this.$message.error('未添加满减规则')
        return false
      }
      let rulesVOList = []
      let numLock = false
      let priceLock = false
      this.tableData.forEach((item, index) => {
        if (index !== this.tableData.length - 1) {
          if (!/^[1-9]\d*$/.test(item.baseDiscountQty)) {
            numLock = true
          } else if (!this.$reg.price.reg.test(item.discountBasePagePrice) || !this.$reg.price.reg.test(item.discountOnlineBasePagePrice)) {
            priceLock = true
          }

          rulesVOList.push({
            baseDiscountQty: item.baseDiscountQty,
            discountBasePagePrice: item.discountBasePagePrice,
            discountOnlineBasePagePrice: item.discountOnlineBasePagePrice,
            skuGroupId: this.selectedInfo.sku.skuGroupId,
            skuId: this.selectedInfo.sku.id,
            spuId: this.selectedInfo.sku.spuId
          })
        }
      })

      if (numLock) {
        this.$message.error('数量需大于0')
        return false
      } else if (priceLock) {
        this.$message.error('价格' + this.$reg.price.message)
        return false
      }

      skuDiscountRuleAddBatch(rulesVOList)
        .then(res => {
          if (res.data.success) {
            this.$message.success('已申请')
            this.$router.go(-1)
          }
        })
    },
    deleteRow (index) {
      this.tableData.splice(index, 1)
    },
    addRow () {
      this.tableData.push({
        baseDiscountQty: '',
        discountBasePagePrice: '',
        discountOnlineBasePagePrice: ''
      })
    },
    select (row) {
      console.log(row)
      if (this.selectForm.isSeries) {
        skuList(row.id).then(res => {
          if (res.data.success) {
            let info = {
              isSeries: this.selectForm.isSeries,
              skuGroup: row,
              sku: res.data.data.filter(item => {
                return !item.themeId
              })[0]
            }
            this.selectedInfo = info
            console.log(info)
            this.tableData.push({
              baseDiscountQty: '',
              discountBasePagePrice: '',
              discountOnlineBasePagePrice: ''
            })
            this.selectDialog = false
          }
        })
      } else {
        let info = {
          isSeries: this.selectForm.isSeries,
          skuGroup: this.selectForm.skuGroup,
          sku: row
        }
        this.selectedInfo = info
        console.log(info)
        this.tableData.push({
          baseDiscountQty: '',
          discountBasePagePrice: '',
          discountOnlineBasePagePrice: ''
        })
        this.selectDialog = false
      }
    },
    // 获得sku组下sku列表
    getSkuListBySkuGroupId () {
      skuList(this.selectForm.skuGroup.id).then(res => {
        // 是否过滤样品
        this.skuList = res.data.data.filter(item => {
          return !item.themeId
        })
      })
    },
    // 获取产品的SKU组详细信息
    getSpuMsg () {
      this.selectForm.isSeries = this.spuList.filter(item => {
        return item.id === this.selectForm.selectSpuId
      })[0].isSeries

      skuGroupListBySpuId({ pageNum: 1, pageSize: 1000, spuId: this.selectForm.selectSpuId }).then(res => {
        if (res.data.success) {
          this.skuGroupListBySpuId = res.data.data.records.filter(item => {
            return item.onSale
          })
        }
      })
    },
    // 获取产品列表
    getSpuList (val) {
      spuList({ pageNum: this.spuQueryInfo.pageNum, pageSize: this.spuQueryInfo.pageSize, spuVO: { categoryId: val, onSale: 1, spuProperty: this.$route.query.spuProperty } }).then(res => {
        if (res.data.success) {
          this.spuList = res.data.data.records
        }
      })
    }
  }
}
</script>
 <style scoped lang="less">
@deep: ~">>>";
</style>
